require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./15-yrfixeddisclosure.json") })
        }
      }, "path---15-yrfixeddisclosure");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---15-yrfixeddisclosure!./.cache/json/15-yrfixeddisclosure.json
// module id = 1529
// module chunks = 231608221292675